import { AlertTriangle, CheckCircle2, CircleAlert, Info, Inbox, LockKeyhole, RotateCw } from "lucide-react";
import type { ReactNode } from "react";
import { Button } from "./controls";

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="ui-state ui-empty-state">
      <span className="ui-state-icon" aria-hidden="true"><Inbox size={20} /></span>
      <strong>{title}</strong>
      {description && <p>{description}</p>}
      {action}
    </div>
  );
}
export function ErrorState({
  title = "İçerik yüklenemedi",
  description = "Bağlantınızı kontrol edip yeniden deneyin.",
  onRetry,
}: {
  title?: string;
  description?: string;
  onRetry?: () => void;
}) {
  return (
    <div className="ui-state ui-error-state" role="alert">
      <span className="ui-state-icon" aria-hidden="true"><AlertTriangle size={20} /></span>
      <strong>{title}</strong>
      <p>{description}</p>
      {onRetry && <Button variant="secondary" onClick={onRetry}><RotateCw size={16} />Tekrar dene</Button>}
    </div>
  );
}

export function PermissionState({ description }: { description?: string }) {
  return (
    <div className="ui-state ui-permission-state">
      <span className="ui-state-icon" aria-hidden="true"><LockKeyhole size={20} /></span>
      <strong>Bu alana erişiminiz yok</strong>
      {description && <p>{description}</p>}
    </div>
  );
}

type NoticeTone = "info" | "success" | "warning" | "danger";

const noticeIcons = {
  info: Info,
  success: CheckCircle2,
  warning: CircleAlert,
  danger: AlertTriangle,
} satisfies Record<NoticeTone, typeof Info>;

export function InlineNotice({
  tone = "info",
  title,
  children,
  action,
}: {
  tone?: NoticeTone;
  title?: string;
  children: ReactNode;
  action?: ReactNode;
}) {
  const NoticeIcon = noticeIcons[tone];
  return (
    <div
      className={`ui-notice ui-notice-${tone}`}
      role={tone === "danger" ? "alert" : "status"}
    >
      <NoticeIcon size={17} aria-hidden="true" />
      <div>
        {title ? <strong>{title}</strong> : null}
        <span>{children}</span>
      </div>
      {action ? <div className="ui-notice-action">{action}</div> : null}
    </div>
  );
}

export function Skeleton({
  lines = 3,
  label = "İçerik yükleniyor",
}: {
  lines?: number;
  label?: string;
}) {
  return (
    <div className="ui-skeleton" role="status" aria-label={label}>
      {Array.from({ length: lines }, (_, index) => (
        <span key={index} style={{ width: `${Math.max(42, 100 - index * 17)}%` }} />
      ))}
    </div>
  );
}
